<template>
  <footer id="contact">
    <div class="container">
      <div class="footer-main">
        <div class="footer-brand">
          <div class="footer-logo">
            <img src="@/assets/logo.png" alt="KiloSeek Logo">
            <span>千寻搜图</span>
          </div>
          <p class="brand-vision">最新资讯，请关注抖音账号</p>
        </div>

        <div class="footer-contact">
          <div class="qr-wrapper">
            <div class="qr-code" @click="showQRModal = true">
              <img src="@/assets/contact_douyin.png" alt="抖音二维码" @error="handleImgError">
            </div>
            <span class="qr-hint">扫码关注抖音</span>
          </div>
        </div>
      </div>

      <!-- 二维码弹窗 -->
      <div v-if="showQRModal" class="qr-modal" @click="showQRModal = false">
        <div class="qr-modal-box" @click.stop>
          <span class="qr-modal-close" @click="showQRModal = false">×</span>
          <img src="@/assets/contact_douyin.png" alt="抖音二维码" class="qr-modal-img">
          <p>扫码关注抖音账号</p>
        </div>
      </div>

      <div class="footer-bottom">
        <p class="icp">粤ICP备2025493756号</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'SiteFooter',
  data() {
    return {
      showQRModal: false
    }
  },
  methods: {
    handleImgError() {
    }
  }
}
</script>

<style scoped>
footer {
  background: #0f1923;
  padding: 15px 20px;
  color: #cbd5e0;
}

.container {
  max-width: 900px;
  margin: 0 auto;
  padding: 0 32px;
}

.footer-main {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(255,255,255,0.06);
}

.footer-logo {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
}

.footer-logo img {
  height: 36px;
  width: auto;
}

.footer-logo span {
  font-size: 18px;
  font-weight: 700;
  color: #fff;
}

.brand-vision {
  font-size: 20px;
  color: #94a3b8;
  margin: 0;
}

.footer-contact h4 {
  font-size: 14px;
  font-weight: 700;
  color: #fff;
  margin: 0 0 12px;
  text-align: right;
}

.qr-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}

.qr-code {
  width: 150px;
  height: 150px;
  cursor: pointer;
  transition: transform 0.2s;
}

.qr-code:hover {
  transform: scale(1.05);
}

.qr-code img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.qr-hint {
  font-size: 11px;
  color: #64748b;
}

.qr-modal {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.75);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
  backdrop-filter: blur(4px);
}

.qr-modal-box {
  background: #fff;
  border-radius: 20px;
  padding: 24px;
  text-align: center;
  position: relative;
}

.qr-modal-close {
  position: absolute;
  top: 8px;
  right: 14px;
  font-size: 24px;
  color: #a0aec0;
  cursor: pointer;
  line-height: 1;
}

.qr-modal-close:hover {
  color: #2d3748;
}

.qr-modal-img {
  width: 260px;
  height: 260px;
  object-fit: contain;
}

.qr-modal-box p {
  font-size: 14px;
  color: #4a5568;
  margin: 12px 0 0;
}

.footer-bottom {
  padding-top: 24px;
  text-align: center;
}

.icp {
  color: #ddd !important;
  font-size: 12px;
  margin: 0;
}

@media (max-width: 640px) {
  .footer-main { flex-direction: column; gap: 24px; }
  .footer-contact h4 { text-align: center; }
  .container { padding: 0 16px; }
}
</style>
